const filterViews = {
  docDigital: {
    filtrosFijos: [
      {
        nombre: 'Orden',
        campo: 'orderType',
        tipo: 'text',
        valor: 'DESC'
      }
    ],
    filtrosHabilitadosOmitido: [
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Tipo de comunicación',
        campo: 'tipoTramitacion',
        tipo: 'selectorNotificado',
        opciones: [
          { value: 'COMUNICACION_OFICIAL', label: 'Comunicación Oficial' },
          { value: 'COMUNICACION_INTERNA', label: 'Comunicación Interna' },
          { value: 'FIRMA_DOCUMENTO', label: 'Firma Documento ' }
        ],
        valor: []
      },
      {
        nombre: 'Materia',
        campo: 'materia',
        tipo: 'texto',
        valor: []
      },
      {
        nombre: 'Id',
        campo: 'documento',
        tipo: 'texto',
        valor: []
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto',
        valor: []
      },
      {
        nombre: 'Estado',
        campo: 'estadoTramitacion',
        tipo: 'estadoTramitacion',
        opciones: [
          { value: 'PENDIENTE_VISACION', label: 'Pendiente de visación' },
          { value: 'BORRADOR', label: 'Borrador' },
          { value: 'PENDIENTE_FIRMA', label: 'Pendiente de firma' }
        ],
        valor: []
      },
      {
        nombre: 'Estado recepción',
        campo: 'tipoEtapa',
        tipo: 'estadoEtapa',
        opciones: [
          { value: 'DESTINATARIOS', label: 'Pendiente acuse' },
          { value: 'DESTINATARIOS_DERIVACION', label: 'Pendiente derivación' }
        ],
        valor: []
      },
      {
        nombre: 'Entidad despachadora',
        campo: 'entidadDespachadora',
        tipo: 'recipientEntity',
        valor: []
      },
      // tipoEtapa: DESTINATARIOS
      {
        nombre: 'Tipo documento',
        campo: 'tipoDocumento',
        tipo: 'documentType',
        valor: []
      },

    ],
    filtrosHabilitados: []
  },
  recibidos: {
    filtrosHabilitados: [
      {
        nombre: 'Notificado',
        campo: 'notificado',
        tipo: 'selectorNotificado',
        opciones: [
          { value: 'true', label: 'Si' },
          { value: 'false', label: 'No' }
        ],
        valor: 'false',
        valorFormateado: 'No',
        inicial: true
      }
    ]
  },
  salientes: {
    filtrosHabilitados: [
      {
        nombre: 'Entidad Destinataria',
        campo: 'entidadDestinataria',
        tipo: 'recipientEntity',
        valor: []
      },
    ]
  }
};

export default {
  data() {
    return filterViews;
  },
  methods: {
    getFilterView(view) {
      const toFilter = filterViews[view];
      if (toFilter) {
        const filter = {
          filtrosFijos: [
            ...filterViews.docDigital.filtrosHabilitados
          ],
          filtrosHabilitados: [
            ...filterViews.docDigital.filtrosHabilitados
          ]
        };
        if (toFilter.filtrosHabilitados) {
          filter.filtrosHabilitados = filter.filtrosHabilitados
            .filter((item) => !toFilter.filtrosHabilitados
              .some((finding) => finding.campo === item.campo))
            .concat(toFilter.filtrosHabilitados);
        }

        return filter;
      }
      return filterViews.docDigital;
    }
  }
};
